import ArticleStore from './store'
export const articleStore = new ArticleStore()
